/*
 * @Description: 银行常量
 * @Date: 2022-10-10 17:09:34
 */

export const PAY_BANK_TYPE_KEY = 'payPassagewayCode'; // 银行I/O字段

export const PAY_TYPE_KEY = 'payType'; // 服务商付款方式

export const OPEN_STATUS_MAPPING = {
  0: {
    label: '未开户',
    value: 0
  },
  1: {
    label: '开户中',
    value: 1
  },
  2: {
    label: '已开户',
    value: 2
  },
  3: {
    label: '开户失败',
    value: 3
  }
};

export const CASH_OUT_TYPE_MAPPING = {
  0: {
    label: '手动提现',
    value: 0
  },
  1: {
    label: '自动提现',
    value: 1
  },
  2: {
    label: '系统关闭',
    value: 2
  }
};

// 众邦黑名单原因
export const ZB_BLACKLMT_RSN_LIST = {
  1: '证件到期',
  2: '长期无交易',
  3: '经营状态异常',
  4: '其他',
  5: '手动设置'
};
